import { Button, Markdown } from '@wot/components';
import { ILegal } from '@wot/typings';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import legalApi from '../../../api/legal';

export function TermsConditions() {
  const [terms, setTerms] = useState<ILegal[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    legalApi
      .getDocuments('terms-conditions')
      .then((data) => {
        if (data) {
          setTerms(data);
        }
      })
      .catch((err) => err);
  }, []);

  if (terms.length === 0) {
    return (
      <div className="w-max">
        <Link to={'terms-conditions'} state={{ mode: 'edit' }}>
          <Button text={'Add Terms And Conditions'} onClick={() => { }} />
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      {terms.map((term) => (
        <div
          key={term._id}
          onClick={() => {
            navigate('terms-conditions', {
              state: {
                doc: term,
                mode: term.status === 'active' ? 'edit' : 'view'
              }
            });
          }}
          className={`w-full flex flex-col gap-5 cursor-pointer ${term.status === 'active' ? 'bg-neutralBlue2' : 'bg-white border'
            } p-5 rounded-md`}
        >
          <div className="w-full flex items-center justify-between">
            <h1 className="text-base font-semibold">{dayjs(term.createdAt).format('DD/MM/YYYY')}</h1>
            {term.status === 'active' && (
              <div className="flex gap-4 items-center justify-center">
                <Button
                  text={'Update'}
                />
              </div>
            )}
          </div>
          <div className="w-full">
            <Markdown markdown={term.mdText} />
          </div>
        </div>
      ))}
    </div>
  );
}
